import {
  ScrollTrigger
} from "./chunk.RYXMHMS2.js";
import {
  gsapWithCSS
} from "./chunk.LXB4MYP4.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-campaign-page-hero-fullscreen/jb-campaign-page-hero-fullscreen.scss?inline
var jb_campaign_page_hero_fullscreen_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
p {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h1 {
  font-family: var(--theme-font-xlight-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-xlight-weight, 200);
}

h1 {
  font-size: var(--theme-typo-h1-overview-mobile-fontsize, 1.75rem);
  letter-spacing: var(--theme-typo-h1-overview-mobile-letterspacing, 0.094rem);
  line-height: var(--theme-typo-h1-overview-mobile-lineheight, 2.5rem);
}
@media (min-width: 1281px) {
  h1 {
    font-size: var(--theme-typo-h1-overview-desktop-fontsize, 3.125rem);
    letter-spacing: var(--theme-typo-h1-overview-desktop-letterspacing, 0.25rem);
    line-height: var(--theme-typo-h1-overview-desktop-lineheight, 4.375rem);
  }
}

p {
  font-size: var(--theme-typo-p-big-mobile-fontsize, 1.188rem);
  line-height: var(--theme-typo-p-big-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  p {
    font-size: var(--theme-typo-p-big-desktop-fontsize, 1.375rem);
    line-height: var(--theme-typo-p-big-desktop-lineheight, 2.125rem);
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --host-color: #fff;
  display: block;
  isolation: isolate;
}

section {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.part1 {
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100vh;
  justify-content: center;
  position: relative;
  width: 100%;
}
.part1::after {
  background-color: rgba(0, 0, 0, 0.4);
  content: "";
  display: block;
  inset: 0;
  position: absolute;
  z-index: 1;
}

.background {
  background-attachment: fixed;
  background-color: #141e55;
  background-position: center;
  background-size: cover;
  inset: 0;
  position: absolute;
}
.background--mobile {
  background-attachment: unset;
  display: block;
}
@media (min-width: 960px) {
  .background--mobile {
    display: none;
  }
}
.background--desktop {
  display: none;
}
@media (min-width: 960px) {
  .background--desktop {
    display: block;
  }
}
.background--video {
  overflow: hidden;
}

.inner {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 20px;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 50%;
  margin: auto;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 2;
}

h1,
p {
  text-align: center;
  z-index: 2;
}

h1 {
  cursor: pointer;
  text-transform: uppercase;
}
@media (min-width: 960px) {
  h1 {
    box-sizing: border-box;
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    padding: 0 20px;
    width: 91.6666666667%;
    margin: 0 auto;
  }
}

p {
  margin-top: 16px;
}
@media (min-width: 960px) {
  p {
    box-sizing: border-box;
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    padding: 0 20px;
    width: 66.6666666667%;
    margin: 16px auto;
  }
}

.buttons {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 26px;
  --stroke-color: #fff;
}
.buttons jb-button + jb-button {
  margin: 20px auto 0;
}
@media (min-width: 600px) {
  .buttons jb-button + jb-button {
    margin-left: 20px;
    margin-right: 0;
    margin-top: 0;
  }
}
@media (min-width: 600px) {
  .buttons {
    flex-direction: row;
    justify-content: center;
  }
}
@media (min-width: 960px) {
  .buttons {
    margin-top: 16px;
  }
}`;

// src/components/jb-campaign-page-hero-fullscreen/jb-campaign-page-hero-fullscreen.ts
var JbCampaignPageHeroFullscreen = class extends h {
  firstUpdated() {
    gsapWithCSS.registerPlugin(ScrollTrigger);
    gsapWithCSS.to(this._inner, {
      scrollTrigger: {
        trigger: this._detector,
        scrub: 0,
        start: "top bottom",
        end: "+=50%"
      },
      yoyo: true,
      opacity: 0,
      scale: 0.8
    });
  }
  _renderHeroImage() {
    if (this.videoSrc) {
      return ke`<jb-video
        class="background"
        .src=${this.videoSrc}
        isBackground
      ></jb-video>`;
    }
    return ke`<div
        class="background background--desktop"
        style="background-image: url('${this.image}');"
      ></div>
      <div
        class="background background--mobile"
        style="background-image: url('${this.mobileImage}');"
      ></div>`;
  }
  _scrollToContent() {
    window.scrollBy({ top: window.innerHeight, left: 0, behavior: "smooth" });
  }
  _tracking(e2) {
    if (e2.detail.type === "download") {
      const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
        component_name: "campaign-page-hero"
      });
      if (jbTrackingEvent) this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`<section>
      <div class="part1">
        ${this._renderHeroImage()}
        <div class="inner">
          <div class="cta">
            ${this.headline ? ke`<h1 @click=${this._scrollToContent}>${this.headline}</h1>` : D}
            ${this.text ? ke`<p>${this.text}</p>` : D}
            ${this.buttons ? ke`<div class="buttons">
                    ${this.buttons.map(
      (button) => ke`<jb-button
                          @jb-link:clicked=${this._tracking}
                          .text=${button.text}
                          .link=${button.link}
                        ></jb-button>`
    )}
                  </div>` : D}
          </div>
        </div>
      </div>
    </section><div id="detector"></div></div>`;
  }
};
JbCampaignPageHeroFullscreen.styles = r(jb_campaign_page_hero_fullscreen_default);
__decorateClass([
  n({ type: Array })
], JbCampaignPageHeroFullscreen.prototype, "buttons", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "headline", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "image", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "mobileImage", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "text", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "videoSrc", 2);
__decorateClass([
  e("#detector")
], JbCampaignPageHeroFullscreen.prototype, "_detector", 2);
__decorateClass([
  e(".inner")
], JbCampaignPageHeroFullscreen.prototype, "_inner", 2);
JbCampaignPageHeroFullscreen = __decorateClass([
  customElement("jb-campaign-page-hero-fullscreen")
], JbCampaignPageHeroFullscreen);

export {
  JbCampaignPageHeroFullscreen
};
